import useTranslation from 'next-translate/useTranslation';
import { useDispatch, useSelector } from 'react-redux';

import {
  actions as cabinetActions,
  selectors as cabinetSelectors,
} from '@/domains/cabinet';
import OwnPhoneInput from '@/ui/OwnPhoneInput/OwnPhoneInput';
import { Button, ErrorModal, ScreenLoader } from '@/ui/index';
import useOtpVerification from '@/hooks/useOtpVerification';
import CountDown from '@/components/common/RecordModal/CountDown';
import { formatTimer } from '@/utils/formatTimer';

import styles from './OtpVerify.module.scss';

export const OtpVerify = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    isLoading,
    wrongOtp,
    showError,
    otpRequested,
    otpValue,
    formatPhoneNumber,
    submitHandler,
    handleChangeOtpInput,
    closeError,
    count,
  } = useOtpVerification({ isPopup: false });
  const { phoneNumber } = useSelector(cabinetSelectors.selectCabinet);
  return (
    <>
      <ScreenLoader
        visible={isLoading}
        itemScope
        itemType='https://schema.org/Thing'
      />
      <div
        className={styles.otpFormWrapper}
        itemScope
        itemType='https://schema.org/Action'
      >
        <form
          className={styles.otpFormWrapper__form}
          onSubmit={(e) => submitHandler(e)}
        >
          <p className={styles.otpText}>{t('cabinet:common.OTP')}</p>
          <span className={styles.otpSubText}>
            {t('cabinet:common.OtpSent')} <span></span>
            {formatPhoneNumber(phoneNumber)}
          </span>
          <CountDown />
          <OwnPhoneInput
            className={styles.otpInput}
            separationPoints={[]}
            value={otpValue}
            onChange={handleChangeOtpInput}
            placeholder='_'
          />
          {wrongOtp && (
            <p className={styles.wrong_otp}> {t('cabinet:common.WrongOtp')}</p>
          )}

          {otpRequested ? (
            <Button
              variant='outline'
              className={`${styles.button} ${styles.disabled}`}
            >
              {t('cabinet:common.Timer')} : {formatTimer(count)}m
            </Button>
          ) : (
            <Button
              className={`${styles.button} ${styles.resend}`}
              variant='normal'
            >
              {t('cabinet:common.ResendOtp')}
            </Button>
          )}
          <span className={styles.belongsText}>
            {t('cabinet:common.Belong')}{' '}
            <span
              onClick={() => dispatch(cabinetActions.prevStep())}
              className={styles.belongsText__inside}
            >
              {t('cabinet:common.EditNumber')}
            </span>
          </span>
        </form>

        <ErrorModal
          active={showError}
          icon='/assets/error.png'
          setActive={closeError}
        >
          {t('common:vacancies.error')}
        </ErrorModal>
      </div>
    </>
  );
};
